export default __webpack_public_path__ + "static/media/icon-red-cross.dd76e3e7.svg";